import {IUserRole} from '../admin-api/models';


export type IUserListResponse = {
    users: IUserItemResponse[]
}

export type IUserItemResponse = {
    id: string,
    firstName: string,
    middleName?: string,
    lastName: string,
    email: string,
    wallets: IWallet[]
}

export type IWallet = {
    id: string,
    name: string,
    currency: string,
    balance: number
    efficientBalance: number
    withdrawalBalance: number
    totalAccrualOfInterest: number
    percentOfAllAccrualOfInterest: number
    lastAccrualOfInterestPercents: number
}

export type IUserDetailsResponse = {
    id: string,
    firstName: string,
    middleName: string,
    lastName: string,
    phoneNumber: string,
    email: string,
    birthDate: string,
    roles: {
        id: string,
        name: string,
        type: IUserRole
    }[],
    wallets: TWallet[]
}

export type TWallet = {
    id: string,
    name: string,
    currency: string,
    balance: number,
    efficientBalance: number,
    withdrawalBalance: number,
    totalAccrualOfInterest: number,
    percentOfAllAccrualOfInterest: number,
    lastAccrualOfInterest: number,
    lastAccrualOfInterestPercents: number
}

export type ICurrentUserResponse = {
    id: string,
    name: string,
    roles: IUserRole[]
}

export type IUpdateUserInfo = {
    id: string,
    firstName: string,
    middleName: string,
    lastName: string,
    phoneNumber: string,
    birthDate: string
}

export type IDashboardItemsRequest = {
    walletId: string,
    takeLast: number
}

export type IDashboardItemsResponse = {
    items: {
        date: string,
        balance: number,
        efficientBalance: number,
        withdrawalBalance: number,
        operationType: IDashboardOperationTypeRsp
    }[]
}

export type IAccrualOfInterestDashboardItemsResponse = {
    items: {
        date: string,
        balanceDiff: number,
        balanceDiffPercent: number
    }[]
}

export enum IDashboardOperationTypeRsp {
    withdrawalRequest = 'withdrawalRequest',
    deposit = 'deposit',
    accrualOfInterest = 'accrualOfInterest'
}

export type IGetUserOperationsRequest = {
    userId: string,
    statuses: IStatusOperation[],
    skip: number,
    take: number
}

export type IGetUserReportRequest = {
    userId: string,
    walletId: string,
    dateFrom?: string,
    dateTo?: string,
}

export enum IStatusOperation {
    undefined = 'undefined',
    notApproved = 'notApproved',
    approved = 'approved',
    rejected = 'rejected',
    cancelled = 'cancelled'
}

export type IGetUserOperationsResponse = {
    items: IOperationItem[],
    totalCount: number
}

export type IGetUserReportResponse = {
    items: IUserReport[],
}

export type IUserReport = {
    "userId": string,
    "walletId": string,
    "currency": string,
    "firstName": string,
    "middleName": string,
    "lastName": string,
    "periodStart": string,
    "periodEnd": string,
    "effectiveBalanceStart": number,
    "balanceStart": number,
    "balanceEnd": number,
    "commission": number,
    "balanceDifference": number,
    "balanceDifferencePercent": number,
    "balanceEndNoCommission": number,
    "totalProfit": number,
    "withdrawalsTotal": number,
    "depositsTotal": number,
    "depositsMinusWithdrawalsTotal": number
}


export type IOperationItem = {
    status: IStatusOperation,
    operationDate: string,
    completeDate?: string,
    wallet: {
        id: string,
        name: string,
        currency: string,
        balance: number,
        withdrawalBalance: number,
        efficientBalance: number,
        totalAccrualOfInterest: number,
        percentOfAllAccrualOfInterest: number,
        lastAccrualOfInterestPercents: number
    },
    walletOwnerId: string,
    walletOwnerEmail: string,
    balanceDiff: number,
    comment?: string,
    type?: string
}

export type IUserInterface = {
    getAllUsersList()
    getUserDetails(userId: string)
    getCurrentUser()
    updateUserInfo(data: IUpdateUserInfo)
    updatePassword(oldPassword: string, newPassword: string)

    getDashboardItems(data: IDashboardItemsRequest)
    getUserOperationsList(data: IGetUserOperationsRequest)


}
